import * as Sentry from "@sentry/react";

// Log exceptions with full context
const logSentryException = ({
    err,
    phoneNumber = null,
    userName = null,
    customTags = {},
}) => {
    try {
        Sentry.captureException(err, {
            tags: customTags,
            extra: {
                phoneNumber: phoneNumber || null,
                userName: userName || null,
            },
        });
    } catch (error) {
        console.error("Failed to send Sentry exception:", error);
    }
};

// Log a non-error message (e.g., event tracking)
const logSentryMessage = (message, level = "info", customTags = {}) => {
    try {

        Sentry.captureMessage(message, {
            level,
            tags: customTags,
        });
    } catch (error) {
        console.error("Failed to send Sentry message:", error);
    }
};

// Add a breadcrumb (e.g., user clicked button)
const addSentryBreadcrumb = ({ category, message, level = "info", data = {} }) => {
    try {

        Sentry.addBreadcrumb({
            category,
            message,
            level,
            data,
        });
    } catch (error) {
        console.error("Failed to add Sentry breadcrumb:", error);
    }
};

// Set user context manually
const setSentryUser = ({ phoneNumber, userName }) => {
    try {

        Sentry.setUser({
            username: userName || null,
            email: phoneNumber || null,
        });
    } catch (error) {
        console.error("Failed to set Sentry user context:", error);
    }
};

export {
    logSentryException,
    logSentryMessage,
    addSentryBreadcrumb,
    setSentryUser,
};
